import { r as registerInstance, h, H as Host, g as getElement } from './index-5faac9d7.js';
import { u as updateStorage, a as state, g as getSettings, H as HostTypeValues } from './store-a2f488b2.js';
import './index-54dd34b7.js';
import './currency-49e0d692.js';

const priceCss = ".pes-cc-price{padding:0;margin:6px 0;font-weight:bold;color:#333333;font-size:18px;line-height:25px}@media screen and (min-width: 980px){.pes-cc-price{font-size:16px}:host(:not([dir=\"rtl\"])) .pes-cc-price{text-align:left}:host([dir=\"rtl\"]) .pes-cc-price{text-align:right}}.pes-cc-price__label{font-size:14px;line-height:1.4285714286;display:block;margin-bottom:10px;font-weight:normal}";

const CommerceConnectorPrice = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productId = undefined;
    this.price = undefined;
    this.priceFromLabel = undefined;
  }
  priceBroadcastHandler(event) {
    const { detail: { prices, priceFromLabel }, } = event;
    if (this.productId in prices) {
      this.price = prices[this.productId];
      this.priceFromLabel = priceFromLabel;
    }
  }
  render() {
    if (!this.price) {
      return;
    }
    return h("div", { class: "pes-cc-price" }, h("span", { class: "pes-cc-price__label" }, this.priceFromLabel), h("span", null, this.price));
  }
};
CommerceConnectorPrice.style = priceCss;

const name = "@pes-ui/components";
const version = "4.1.0-PES-25.2.0.0";

const PES_SPRYKER_ENDPOINTS = [
  'https://glue.pes-sqe.se.com',
  'https://glue.pes-ppr.se.com',
];

const controlPanelCss = "@charset \"UTF-8\";:host{direction:ltr;width:calc(100% - 22px);max-width:600px;display:flex;flex-direction:column;position:fixed;top:calc(100vh - 41px);border-top-left-radius:40px;border-top-right-radius:40px;border:1px solid #333333;border-bottom:none;padding:0 10px 10px;z-index:1000}@media screen and (min-width: 980px){:host{left:calc(50vw - 300px) }}:host(.open){top:auto;bottom:0;background:#eee}h2{text-align:center;margin:0;line-height:40px;cursor:pointer}label,summary{min-width:100px;display:inline-block}section:not(.settings--outline):not(:last-child),details:not(:last-child){padding:1px 0}details{display:flex;flex-direction:column}summary{cursor:pointer}details>summary::before,details>summary::after{content:\"▼▼▼\"}details[open]>summary::before,details[open]>summary::after{content:\"▲▲▲\"}@media screen and (min-width: 980px){section:not(.settings--wide),details:not(.settings--wide){width:50%}}@media screen and (min-width: 980px){section.settings--extra section:not(.settings--wide){width:100%}}textarea{width:100%;height:300px}textarea,input,select{font-size:16px}.input--wide{width:100%}.version--section{margin-bottom:6px}.settings--extra{display:grid;width:100%;grid-template-columns:50% 50%;align-items:start}.settings--outline{box-sizing:border-box;padding:10px;margin:10px 0;outline:1px solid #626469}.settings--outline+.settings--outline{margin-top:0}";

const ControlPanel = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.endpointUrls = [
      'https://www.se.com/',
      'https://www.schneider-electric.',
      'http://www-prdpes.ecom.schneider-electric.com/',
      'https://www-pre.se.com/',
      'http://www-pre.schneider-electric.',
      'http://www-preprdpes.ecom.schneider-electric.com/',
      'https://www-sqe.se.com/',
      'http://www-sqe.schneider-electric.',
      'http://www-sqepes.ecom.schneider-electric.com/',
      'http://www-oosqepes.ecom.schneider-electric.com/',
      'http://www-intpes.ecom.schneider-electric.com/',
    ];
    this.pesSprykerHosts = PES_SPRYKER_ENDPOINTS;
    this.appTypes = [
      { text: 'PES Business Service', value: 'pesCatalog' },
      { text: 'Commerce Connector', value: 'commerceConnector' },
    ];
    this.pages = [
      { text: 'All products', value: '' },
      { text: 'Category', value: 'category' },
      { text: 'Subcategory', value: 'subcategory' },
      { text: 'Range (prp)', value: 'range' },
      { text: 'Product (pdp)', value: 'product' },
    ];
    this.dirTypes = [
      { text: 'ltr', value: 'ltr' },
      { text: 'rtl', value: 'rtl' },
      { text: 'auto', value: 'auto' },
    ];
    this.hostTypes = [
      { text: 'Atg', value: 'Atg' },
      { text: 'Spryker', value: 'Spryker' },
    ];
    this.useS3Types = [
      { text: 'Yes', value: 'Yes' },
      { text: 'No', value: 'No' },
    ];
    this.onImport = () => {
      if (this.importedSettings) {
        updateStorage(this.importedSettings);
        window.location.reload();
      }
    };
    this.onImportChange = (e) => {
      this.importedSettings = e.target.value;
    };
    this.onImportToggle = () => {
      this.importExpanded = !this.importExpanded;
    };
    this.isOpen = false;
    this.application = undefined;
    this.useS3 = undefined;
    this.host = undefined;
    this.endpoint = undefined;
    this.base_dir = undefined;
    this.showCustomPrice = false;
    this.showCatalogPrice = true;
    this.returnBreadcrumbs = undefined;
    this.showBreadcrumbs = false;
    this.showBuyOnline = true;
    this.showLinks = true;
    this.showCompare = false;
    this.showFaq = false;
    this.showRecentlyViewed = false;
    this.showDocuments = true;
    this.importedSettings = '';
    this.importExpanded = false;
    this.searchParams = {};
    this.ddcAppSource = '';
    this.ddcAllProductsUrl = '';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  onSettingsChange(e, setting, castCallback) {
    console.log(JSON.stringify({ setting, value: e.detail }));
    if (e.detail !== undefined) {
      const value = e.detail.toString();
      state.set(setting, castCallback ? castCallback(value) : value);
    }
    else if (e.target.type === 'checkbox') {
      const value = e.target && e.target.checked;
      state.set(setting, castCallback ? castCallback(value) : value);
    }
    else {
      const value = e.target && e.target.value;
      state.set(setting, castCallback ? castCallback(value) : value);
    }
  }
  toggleOpen() {
    this.isOpen = !this.isOpen;
  }
  render() {
    return (h(Host, { class: this.isOpen ? 'open' : '' }, h("h2", { onClick: () => this.toggleOpen() }, "Testing control panel"), h("section", { class: "settings--wide version--section" }, h("label", null, "Package-version: ", name, " - ", version)), h("section", { class: "settings--wide" }, h("label", null, "Application type:"), h("pes-radio", { "group-id": "appType", items: this.appTypes, onPesRadioChange: (e) => this.onSettingsChange(e, 'appType'), "selected-value": state.get('appType') })), h("section", { class: "settings--wide" }, h("label", null, "Use S3 locales:"), h("pes-radio", { "group-id": "useS3", items: this.useS3Types, onPesRadioChange: (e) => this.onSettingsChange(e, 'useS3', (value) => value === 'Yes'), "selected-value": state.get('useS3') ? 'Yes' : 'No' })), !state.get('useS3') && (h("section", { class: "settings--wide" }, h("label", null, "Host type:"), h("pes-radio", { "group-id": "hostType", items: this.hostTypes, onPesRadioChange: (e) => this.onSettingsChange(e, 'hostType'), "selected-value": state.get('hostType') }))), h("section", { class: "settings--wide" }, h("label", null, "Host (clear input and click to see all options):"), h("input", { class: "input--wide", type: "text", list: "url", onChange: (e) => this.onSettingsChange(e, 'host'), value: state.get('host') }), h("datalist", { id: "url" }, state.get('hostType') === HostTypeValues.Spryker
      && this.pesSprykerHosts.map((url, index) => h("option", { key: index }, url)), state.get('hostType') === HostTypeValues.Atg
      && this.endpointUrls.map((url, index) => h("option", { key: index }, url)))), h("section", { class: "settings--wide settings--extra" }, state.get('appType') === 'pesCatalog' && [
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'usePesRouter'), checked: state.get('usePesRouter') }), h("label", null, "Use router parser")),
    ], state.get('appType') === 'pesCatalog' && state.get('usePesRouter') && (h("section", null, h("label", null, "Routing type:"), h("pes-radio", { "group-id": "routing-type", items: [
        { text: 'path', value: 'path' },
        { text: 'hash', value: 'hash' },
      ], onPesRadioChange: (e) => this.onSettingsChange(e, 'pesRouterNavigation'), "selected-value": state.get('pesRouterNavigation') })))), h("section", { class: "settings--wide" }, state.get('appType') === 'pesCatalog' && [
      !state.get('usePesRouter') && [
        h("section", { class: "settings--wide settings--extra settings--outline" }, h("details", { class: "settings--wide" }, h("summary", null, "Page (click to expand)"), h("pes-radio", { class: "radio--column", "group-id": "page", items: this.pages, onPesRadioChange: (e) => this.onSettingsChange(e, 'page'), "selected-value": state.get('page') })), h("section", { class: "settings--wide" }, h("section", { class: "settings--wide" }, h("label", null, "Page Id"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'pageId'), value: state.get('pageId') })), h("section", { class: "settings--wide" }, h("label", null, "Search Params"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'searchParams'), value: state.get('searchParams') })))),
      ],
    ], h("section", { class: "settings--wide settings--extra settings--outline" }, (state.get('appType') === 'pesCatalog'
      || state.get('appType') === 'commerceConnector') && [
      !state.get('usePesRouter') && [
        h("section", { class: "settings--wide" }, h("label", null, "Country"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'country'), value: state.get('country') })),
        h("section", { class: "settings--wide" }, h("label", null, "Language"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'language'), value: state.get('language') })),
      ],
    ])), h("section", { class: "settings--wide settings--extra" }, state.get('appType') === 'pesCatalog' && [
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showDocuments'), checked: state.get('showDocuments') }), h("label", null, "Show documents")),
      h("section", { class: "settings--wide" }, h("label", null, "DDC appSource:"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'ddcAppSource'), value: state.get('ddcAppSource') })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showCompare'), checked: state.get('showCompare') }), h("label", null, "Show compare control")),
      h("section", { class: "settings--wide" }, h("label", { title: "(all-products)" }, "DDC URL:"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'ddcAllProductsUrl'), value: state.get('ddcAllProductsUrl') })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showFaq'), checked: state.get('showFaq') }), h("label", null, "Show FAQ")),
      h("section", null, h("div", null, h("label", null, "Show buy online cta:")), h("pes-radio", { "group-id": "showBuyOnline", items: [
          { text: 'view details', value: 'false' },
          { text: 'show buy online', value: 'true' },
        ], onPesRadioChange: (e) => this.onSettingsChange(e, 'showBuyOnline'), "selected-value": state.get('showBuyOnline').toString() })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showBreadcrumbs'), checked: state.get('showBreadcrumbs') }), h("label", null, "Show breadcrumbs")),
      h("section", null, h("label", null, "HTML dir:"), h("pes-radio", { "group-id": "dir", items: this.dirTypes, onPesRadioChange: (e) => this.onSettingsChange(e, 'dir'), "selected-value": state.get('dir') })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showDiscountedPrice'), checked: state.get('showDiscountedPrice') }), h("label", null, "Show Discounted Price")),
      h("section", null, h("label", null, "Endpoint:"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'endpoint'), value: state.get('endpoint') })),
      h("section", null, h("input", { type: "checkbox", onChange: (e) => this.onSettingsChange(e, 'showRecentlyViewed'), checked: state.get('showRecentlyViewed') }), h("label", null, "Show recently viewed")),
      h("section", null, h("label", null, "Site Type:"), h("select", { onChange: (e) => this.onSettingsChange(e, 'siteType') }, h("option", { selected: state.get('siteType') === 'b2b', value: "b2b" }, "B2B"), h("option", { selected: state.get('siteType') === 'b2c', value: "b2c" }, "B2C"))),
      state.get('usePesRouter') && (h("section", null, h("label", null, "base_dir:"), h("input", { type: "text", onChange: (e) => this.onSettingsChange(e, 'base_dir'), value: state.get('base_dir') }))),
    ], state.get('appType') === 'commerceConnector' && (h("div", null, h("section", null, h("label", null, "Products obj"), h("textarea", { rows: 10, cols: 50, onChange: (e) => this.onSettingsChange(e, 'products'), value: state.get('products') })), h("section", null, h("label", null, "Additional distributors obj"), h("textarea", { rows: 10, cols: 50, onChange: (e) => this.onSettingsChange(e, 'additionalDistributors'), value: state.get('additionalDistributors') })))), h("section", null, this.importExpanded ? (h("div", null, h("label", null, "Import / Export"), h("textarea", { onBlur: this.onImportChange }, getSettings()), h("button", { onClick: this.onImport, disabled: !this.importedSettings }, "Import"), h("button", { onClick: this.onImportToggle }, "Close"))) : (h("button", { onClick: this.onImportToggle }, "Import / Export settings"))))));
  }
  get el() { return getElement(this); }
};
ControlPanel.style = controlPanelCss;

export { CommerceConnectorPrice as pes_cc_price, ControlPanel as pes_settings_control_panel };
